import { AiImageModelType, AiVideoModelEnum, AudioModelType, axiosInstance, TalkingFaceModelType } from '../../utils';
import { AudioCredit } from '../../@types';
import { useMutation } from '@tanstack/react-query';
import { useCreditContext } from '../../../t2c-fe/hooks';
import { AiClipperModelType, UpscaleModelType } from 'libs/shared-fe/src/utils/constants'

interface Payload {
  text?: string;
  isAudioCreation?: boolean;
  aiGenType?: 'video' | 'image' | 'audio';
  duration?: number;
  numGenerations?: number;
  model?: AiVideoModelEnum | AudioModelType | AiImageModelType | TalkingFaceModelType | UpscaleModelType | AiClipperModelType;
  isTrain?: boolean;
}

export const fetchRequiredCredits = async (
  payload: Payload,
  usableCredits: number,
  setUsableCredits: (_: number) => void
): Promise<AudioCredit> => {
  const res = await axiosInstance.post('/api/videos/required-credits', payload);

  if (usableCredits !== res.data?.availableCredits - res.data?.creditsInUse)
    setUsableCredits(res.data?.availableCredits - res.data?.creditsInUse);

  return res.data;
};

export const useFetchRequiredCredits = () => {
  const { setUsableCredits, usableCredits } = useCreditContext();

  return useMutation(
    (payload: Payload) => fetchRequiredCredits(payload, usableCredits, setUsableCredits),
    { onSuccess: (data) => data }
  );
};
